import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    //  横屏状态
    landscapeShow: false,
    //  下单模块是否显示
    chaseShow: false,
    // 修改支付状态
    changePay: false,
    //  蒙版是否显示
  },
  mutations : {
    // landScapeShow( state, msg ){
    //   state.userName = msg;
    // }
    phoneScreen( state, show ){
      state.landscapeShow = show
    },
    chaseBorad( state, show ){
      state.chaseShow = show
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js